interface EnterpretLogoIconProps {
  width?: string;
  height?: string;
  shouldHideLines?: boolean;
}

export const EnterpretLogoIcon = ({
  width = '64',
  height = '64',
  shouldHideLines = false,
}: EnterpretLogoIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 258 258"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_494_75511)">
        {!shouldHideLines && (
          <path
            opacity="0.3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 29.7979H258V56.5368H0V29.7979ZM0 116.076H163.553V143.293H0V116.076ZM258 202.264H0V229.003H258V202.264Z"
            fill="#B065FF"
            fillOpacity="0.8"
          />
        )}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M210.443 40.0936L169.721 0L140.697 28.577H96.2375L67.2126 0L26.4907 40.0936L55.2851 68.4438V101.738L26.4907 130.088L55.2851 158.439V187.926L26.4907 216.276L67.2126 256.369L95.4014 228.615H139.877L169.721 257.999L210.443 217.905L169.721 177.812L145.535 201.625H93.0544L78.3208 187.119V159.245L94.9338 142.888H164.474V115.898H93.522L78.3208 100.931V69.2503L90.6066 57.1543H146.327L169.721 80.1872L210.443 40.0936Z"
          fill="url(#paint0_linear_494_75511)"
          fillOpacity="0.87"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_494_75511"
          x1="48.4999"
          y1="13"
          x2="196"
          y2="193.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E23EFE" />
          <stop offset="0.870179" stopColor="#9454F3" />
        </linearGradient>
        <clipPath id="clip0_494_75511">
          <rect width="258" height="258" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
